import {acTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = acTypes;

const path = `iot/ac`;

const base = new BaseAction(types);

export const getAcDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedAcDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getAcData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedAcData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addAcData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editAcData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteAcData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreAcData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteAcData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
